import { Amplify } from "aws-amplify";
import { I18n } from "@aws-amplify/core";
import { useAuthenticator, Authenticator, useTheme, View, Image, Text, Heading, Button, Link } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import React, { useState, useContext, useEffect } from "react";
import Header from "./component/Header";
import Footer from "./component/Footer";
import ButtonNav from "./component/ButtonNav";
import TextTranslate from "./component/TextTranslate";
import DocTranslate from "./component/DocTranslate";
import DocCorrect from "./component/DocCorrect";
// import { Box } from "@mui/material";
// import { fetchUserAttributes } from "aws-amplify/auth";
import languages from "./languages";
import config from "./amplifyconfiguration.json";
import logo_batua from "./images/logo.png";
import { Message } from "@aws-amplify/ui-react";
import UserLanguageContext from "./UserLanguageContext";

import { Hub } from "aws-amplify/utils";
import { signInWithRedirect, getCurrentUser } from "aws-amplify/auth";
// import { AuthUser } from "aws-amplify/auth";

import { Helmet } from "react-helmet";

import TagManager from 'react-gtm-module'
import { Box } from "@mui/material";
 
const tagManagerArgs = {
    gtmId: 'GTM-KC59MC2P'
}
 
TagManager.initialize(tagManagerArgs)

Amplify.configure(config);

I18n.putVocabularies(languages);

const defaultLanguage = () => {
  const languageFromStorage = localStorage.getItem("lang");
  if (languageFromStorage) {
    I18n.setLanguage(languageFromStorage);
    return languageFromStorage;
  } else {
    const detectedLang = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
    let adaptLang = detectedLang.slice(0, 2);
    if (Object.keys(languages).indexOf(adaptLang) === -1) {
      adaptLang = "eu";
    }
    I18n.setLanguage(adaptLang);
    return adaptLang;
  }
};

I18n.setLanguage("eu"); // Initial language

function App() {
  const [activeTab, setActiveTab] = useState("txt");
  const [language, setLanguage] = useState(defaultLanguage());  

  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload }) => {
      switch (payload.event) {
        case "signInWithRedirect":
          getUser();
          break;
        case "signInWithRedirect_failure":
          console.log("An error has ocurred during the Oauth flow.");
          break;
      }
    });

    getUser();

    return unsubscribe;
  }, []);

  const getUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      // console.error(error);
      console.log("Please sign in");
    }
  };

  return (
   <>
     {/* user !== null ? (
       <AuthenticatedApp user={user} language={language} setlanguage={setLanguage} activeTab={activeTab}></AuthenticatedApp>
     ) : (
       <UnauthenticatedApp language={language} setlanguage={setLanguage}/>
     ) */}
    <div className="App">
    <Helmet>
  {/* title attributes and value */}
  <title>{I18n.get("mainTitle")}</title>

  {/* base element */}
  <base target="_blank" href="https://account.batua.eus/" />

  <meta charset="utf-8" />
  <link
    href="data:image/x-icon;base64,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"
    rel="icon"
    type="image/x-icon"
  />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta name="theme-color" content="#000000" />
  <meta name="description" content="account.batua.eus - Erabilera zabalerako interfazea" />
  <link rel="apple-touch-icon" href="https://account.batua.eus/logo192.png" />

  <meta property="og:title" content="BATUA.eus - Euskarazko itzultzailea" />
  <meta
    property="og:description"
    content={I18n.get("batuamantra")}/>
  <meta property="og:image" content="https://account.batua.eus/banner.png" />
  <meta property="og:url" content="https://account.batua.eus/" />
  <meta name="twitter:title" content="BATUA.eus - Euskarazko itzultzailea" />
  <meta
    name="twitter:description"
    content={I18n.get("batuamantra")}/>
  <meta name="twitter:image" content="https://account.batua.eus/img/banner.png" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="@vicomtech" />
  <meta name="author" content="Vicomtech" />

</Helmet>
    <UserLanguageContext.Provider value={{ language, setLanguage }}>
      <Authenticator formFields={formFields} components={components} initialState="signIn" hideSignUp>
        {() => (
          <>
          <Box sx={{minHeight:'100dvh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <div>
              <Header />
              <Box sx={{
                maxWidth: "1720px",
                marginLeft: "auto",
                marginRight: "auto"
              }}>
                <ButtonNav activeTab={activeTab} setActiveTab={setActiveTab} />
                {activeTab === "txt" && <TextTranslate />}
                {activeTab === "doc" && <DocTranslate />}
                {activeTab === "doc-correct" && <DocCorrect />}
              </Box>
            </div>
            <Footer />
          </Box>
            
            
          </>
        )}
      </Authenticator>
    </UserLanguageContext.Provider>
  </div>
  </>

  );
}

export default App;

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <>
        <View textAlign="center" padding={tokens.space.large}>
          <Image alt="Batua.eus Logoa" src={logo_batua} className="login-logo" />
        </View>
      </>
    );
  },

  Footer() {
    const { tokens } = useTheme();
    const { language, setLanguage } = useContext(UserLanguageContext);
    const [selectedLanguage, setSelectedLanguage] = useState(language);

    const handleUILanguageChange = (langid) => {
      // const l = e.target.value;
      setSelectedLanguage(langid);
      I18n.setLanguage(langid);
      setLanguage(langid);
      localStorage.setItem("lang", langid);
    };

    return (
      <>
        <View textAlign="center" style={{marginTop: "2rem", paddingLeft: "2rem", paddingRight: "2rem"}}>
          <Button as="strong"  fullWidth={true} fontWeight="bold" onClick={() => signInWithRedirect({ provider: { custom: "AzureADVicomtech" } })} size="" variation="primary"  colorTheme="default">
          {/* <IconSave /> */}
            {I18n.get("form-vicomtech-login-link")}
          </Button>
        </View>
        <View textAlign="center" padding={tokens.space.small}>
          {I18n.get("language-change-text-login")}: <Link onClick={() => handleUILanguageChange("eu")}>(eu)</Link>{" "}
          <Link onClick={() => handleUILanguageChange("es")}>(es)</Link> <Link onClick={() => handleUILanguageChange("en")}>(en)</Link>
        </View>
        <Message variation="plain" colorTheme="info">
          <Link isExternal={true} href={I18n.get("contact-link")}>
            {I18n.get("offer-help")}
          </Link>
        </Message>

        <View textAlign="center" padding={tokens.space.large}>
          <Text color={tokens.colors.neutral[80]}>
            &copy;{" "}
            <code>
              <Link isExternal={true} href="https://www.vicomtech.org">
                Vicomtech
              </Link>
              <br />
              your R&D partner for smart digital solutions
            </code>
            {/* <button
          onClick={
            () =>
              signInWithRedirect({ provider: { custom: "AzureADVicomtech" } }) //MyAD is identity provider name in AWS cognito
          }
        >
          Vicomtech Log In
        </button> */}
          </Text>
        </View>
      </>
    );
  },

  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}>{I18n.get("welcome-string")}</Heading>;
    },
    Footer() {
      const { toForgotPassword } = useAuthenticator();

      return (
        <>
        <View textAlign="center">
          <Button fontWeight="normal" onClick={toForgotPassword} size="small" variation="link">
            {I18n.get("form-resetpass-link")}
          </Button>
        </View>


        </>
      );
    },
  },

  SignUp: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Disabled
        </Heading>
      );
    },
    Footer() {
      const { toSignIn } = useAuthenticator();

      return (
        <View textAlign="center">
          <Button fontWeight="normal" onClick={toSignIn} size="small" variation="link">
            Back to
          </Button>
        </View>
      );
    },
  },
  ConfirmSignUp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  SetupTotp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  ConfirmSignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  ForgotPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          {I18n.get("form-resetpass-link")}
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  ConfirmResetPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          {I18n.get("form-resetpass-link")}
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
};

const formFields = {
  signIn: {
    username: {
      label: "Email",
      placeholder: "Email",
      order: 1,
    },
    password: {
      label:"Password",
      placeholder: "Password",
      order: 2,
    },
  },
  signUp: {
    password: {
      label: I18n.get("form-password-label"),
      placeholder: I18n.get("form-password-placeholder"),
      isRequired: false,
      order: 2,
    },
    confirm_password: {
      label: "Confirm Password:",
      order: 1,
    },
  },
  forceNewPassword: {
    password: {
      label: "Password",
      placeholder: "Password",
    },
  },
  forgotPassword: {
    username: {
      label: "Email",
      placeholder: "Email",
    },
  },
  confirmResetPassword: {
    confirmation_code: {
      placeholder: "Confirmation Code",
      label: "Confirmation Code sent via email:",
      isRequired: false,
    },
    confirm_password: {
      placeholder: "Confirm your password Please:",
    },
  },
  setupTotp: {
    QR: {
      totpIssuer: "test issuer",
      totpUsername: "amplify_qr_test_user",
    },
    confirmation_code: {
      label: "New Label",
      placeholder: "Enter your Confirmation Code:",
      isRequired: false,
    },
  },
  confirmSignIn: {
    confirmation_code: {
      label: "New Label",
      placeholder: "Enter your Confirmation Code:",
      isRequired: false,
    },
  },
};
